<nav class="main-header navbar navbar-expand navbar-white">

    <a [routerLink]="" class="brand-link">
        <img src="assets/img/logo.png" alt="Logo" class="brand-image img-circle elevation-3" style="opacity: .8">
        <span class="brand-text font-weight-light fidelis">{{nombreSistema}}</span>
    </a>

    <span class="brand-text font-weight-light fidelis">{{descripcionSistema}}</span>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
        <a [routerLink]="" class="nav-link fidelis" (click)="redirectInicio()">
            <span class="d-none d-md-inline fidelis">Inicio</span>
        </a>
    </ul>
</nav>

<div class="content-wrapper">
    <app-barra-titulo [modulo]="modulo"></app-barra-titulo>
    <section class="content">
        <div class="container-fluid">

            <div class="card card-light">
                <div class="card-header">
                    <h3 class="card-title">
                        <strong>Votación: {{votacion.tituloVotacion}}</strong>
                        <strong style="float: right;">Votos Recibidos: {{votacion.votosRecibidos}}</strong>
                    </h3>
                </div>

                <div class="card-body">

                    <div class="row">

                        <div id="stepperForm" class="bs-stepper col-md-12">
                            <div class="bs-stepper-header">
                                <div class="step" data-target="#test-l-1">
                                    <button class="step-trigger">
                                        <span class="bs-stepper-circle">1</span>
                                        <span class="bs-stepper-label">Resultados</span>
                                    </button>
                                </div>
                                <div class="line"></div>
                                <div class="step" data-target="#test-l-2">
                                    <button class="step-trigger">
                                        <span class="bs-stepper-circle">2</span>
                                        <span class="bs-stepper-label">Votos</span>
                                    </button>
                                </div>
                                <div class="line"></div>
                                <div class="step" data-target="#test-l-3">
                                    <button class="step-trigger">
                                        <span class="bs-stepper-circle">3</span>
                                        <span class="bs-stepper-label">Participantes</span>
                                    </button>
                                </div>
                            </div>
                            <div class="bs-stepper-content">
                                <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
                                    <div id="test-l-1" class="content col-md-12">
                                        <div class="card-body table-responsive table-hover p-0"
                                            style="height: auto; max-height: 600px; padding-bottom: 20px !important;"
                                            *ngFor="let item of listaPreguntas">
                                            <table class="table table-bordered table-head-fixed">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" colspan="4">{{item.pregunta}}</th>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col" width="40%">Opción</th>
                                                        <th scope="col" width="20%">Codificación</th>
                                                        <th scope="col" width="20%">Bloque</th>
                                                        <th scope="col" width="20%">Resultado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let opcion of item.opciones">
                                                        <td class="capitalize">{{opcion.opcion}}</td>
                                                        <td>{{opcion.codificacion}}</td>
                                                        <td>{{opcion.bloque}}</td>
                                                        <td>{{opcion.resultado}}</td>
                                                    </tr>
                                                    <tr [class]="item.claseGanadores"
                                                        *ngFor="let ganador of item.ganadores">
                                                        <td colspan="4" *ngIf="item.claseGanadores === 'ganador';">
                                                            Ganador:
                                                            <strong>{{ganador.opcion}}</strong>
                                                        </td>
                                                        <td colspan="4" *ngIf="item.claseGanadores === 'empate';">
                                                            Empate:
                                                            <strong>{{ganador.opcion}}</strong>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="col-md-12 text-center">
                                            <button type="button" class="text-center btn btn-info col-md-4"
                                                (click)="next()">
                                                <i class="fa fa-arrow-circle-right"></i>
                                                Siguiente
                                            </button>
                                        </div>
                                    </div>
                                    <div id="test-l-2" class="content col-md-12">
                                        <div class="row">
                                            <div class="form-group col-md-9">
                                                <label for="numeroRastreo">Número de Rastreo</label>
                                                <input type="text" class="form-control" id="numeroRastreo"
                                                    formControlName="numeroRastreo">
                                            </div>
                                            <div class="fix-form-group col-md-3">
                                                <button type="button" class="btn btn-info col-md-12"
                                                    (click)="loadTablaVotos(true)">
                                                    <i class="fa fa-search"></i>
                                                    Buscar
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body table-responsive table-hover p-0"
                                            style="height: auto; max-height: 600px; padding-bottom: 20px !important;">
                                            <table class="table table-bordered table-head-fixed">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" width="50%">Número de Rastreo</th>
                                                        <th scope="col" width="50%">Voto</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of tablaVotos.datos">
                                                        <td>{{item.voto}}</td>
                                                        <td>{{item.numeroRastreo}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="card-footer clearfix">
                                            <div class="col-md-6 float-left">
                                                Pagina {{tablaVotos.paginaInicial}} de
                                                {{tablaVotos.paginaFinal}} |
                                                {{tablaVotos.totalRegistros}} Registros
                                            </div>
                                            <ul class="pagination pagination-sm m-0 float-right"
                                                [ngClass]="{'hidden': tablaVotos.ocultarPaginado}">
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotos(true, tablaVotos.links.linkPrimero)">
                                                        &laquo;
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotos(true, tablaVotos.links.linkAnterior)">
                                                        &laquo;
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]="">
                                                        {{tablaVotos.paginaInicial}}
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotos(true, tablaVotos.links.linkSiguiente)">
                                                        &raquo;
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotos(true, tablaVotos.links.linkUltimo)">
                                                        &raquo;
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 text-center fix-margin-top-table">
                                            <button type="button" class="btn btn-info btn-fidelis col-md-4"
                                                (click)="previous()">
                                                <i class="fa fa-arrow-circle-left"></i>
                                                Atrás
                                            </button>
                                            <button type="button" class="btn btn-info btn-fidelis col-md-4"
                                                (click)="next()">
                                                <i class="fa fa-arrow-circle-right"></i>
                                                Siguiente
                                            </button>
                                        </div>
                                    </div>
                                    <div id="test-l-3" class="content col-md-12">
                                        <div class="row">
                                            <div class="form-group col-md-9">
                                                <label for="correoParticipante">Correo del Participante</label>
                                                <input type="email" class="form-control" id="correoParticipante"
                                                    formControlName="correoParticipante">
                                            </div>
                                            <div class="fix-form-group col-md-3">
                                                <button type="button" class="btn btn-info col-md-12"
                                                    (click)="loadTablaVotantes(true)">
                                                    <i class="fa fa-search"></i>
                                                    Buscar Hash
                                                </button>
                                            </div>
                                        </div>
                                        <div class="card-body table-responsive table-hover p-0"
                                            style="height: auto; max-height: 600px;">
                                            <table class="table table-bordered table-head-fixed">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Participante</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of tablaVotantes.datos">
                                                        <td>{{item.hashCorreo}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="card-footer clearfix">
                                            <div class="col-md-6 float-left">
                                                Pagina {{tablaVotantes.paginaInicial}} de
                                                {{tablaVotantes.paginaFinal}} |
                                                {{tablaVotantes.totalRegistros}} Registros
                                            </div>
                                            <ul class="pagination pagination-sm m-0 float-right"
                                                [ngClass]="{'hidden': tablaVotantes.ocultarPaginado}">
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotantes(true, tablaVotantes.links.linkPrimero)">
                                                        &laquo;
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotantes(true, tablaVotantes.links.linkAnterior)">
                                                        &laquo;
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]="">
                                                        {{tablaVotantes.paginaInicial}}
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotantes(true, tablaVotantes.links.linkSiguiente)">
                                                        &raquo;
                                                    </a>
                                                </li>
                                                <li class="page-item">
                                                    <a class="page-link" [routerLink]=""
                                                        (click)="loadTablaVotantes(true, tablaVotantes.links.linkUltimo)">
                                                        &raquo;
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-12 text-center fix-margin-top-table">
                                            <button type="button" class="btn btn-info col-md-4" (click)="previous()">
                                                <i class="fa fa-arrow-circle-left"></i>
                                                Atrás
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
        </div>
    </section>
</div>

<footer class="main-footer row">
    <div class="col-md-12 text-center fidelis">
        Copyright &copy; 2022 {{nombreSistema}}.
        Todos los derechos reservados.
        Versión {{versionSistema}}.
        Ambiente {{ambienteSistema}}.
    </div>
</footer>